import { apiPostRequest, apiGetRequest } from "../utils/webrequests";
import { Communication } from "../data/Communication";

/**
 * Get all communications.
 */
export async function getCommunicationList(): Promise<Communication[]> {
    try {
        const data: Communication[] = await apiGetRequest("GetCommunicationList", {});
        if (!data) {
            throw new Error('No data received from API');
        }
        return data;
    } catch (error: any) {
        console.error("Error fetching communication list:", error);
        throw new Error('Error fetching communication list: ' + error.message);
    }
}

/**
 * Add or Update a communication.
 */
export async function addOrUpdateCommunication(communication: Communication): Promise<string> {
    try {
        const response: string = await apiPostRequest("SaveCommunication", communication);
        return response;
    } catch (error: any) {
        console.error("Error saving communication:", error);
        throw new Error("Error saving communication: " + error.message);
    }
}

/**
 * Delete a communication.
 */
export async function deleteCommunication(communicationId: string): Promise<string> {
    try {
        const response: string = await apiPostRequest(`DeleteCommunication/${communicationId}`, {}); // 👈 PUT ID IN URL
        return response;
    } catch (error: any) {
        console.error("Error deleting communication:", error);
        throw new Error("Error deleting communication: " + error.message);
    }
}
/**
 * Send an email.
 */
export async function sendEmail(subject: string, body: string, recipients: string[]): Promise<string> {
    try {
        const response: string = await apiPostRequest("SendEmail", { subject, body, recipients });
        return response;
    } catch (error: any) {
        console.error("Error sending email:", error);
        throw new Error("Error sending email: " + error.message);
    }
}
